import * as React from 'react';
import { SVGProps } from 'react';

const IconFileDocumentSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 6.5H4v-1h16v1Zm0 4H4v-1h16v1Zm0 4H4v-1h16v1Zm-10 4H4v-1h6v1Z"
    />
  </svg>
);
export default IconFileDocumentSizeM;
